import { render } from "./TaskItem.vue?vue&type=template&id=5218a4d6&ts=true"
import script from "./TaskItem.vue?vue&type=script&lang=ts"
export * from "./TaskItem.vue?vue&type=script&lang=ts"

import "./TaskItem.vue?vue&type=style&index=0&id=5218a4d6&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__